/* eslint-disable react-hooks/exhaustive-deps */

import {
  getPromptVariablesAPI,
  getFilterPromptVariablesAPI,
} from "Api/promptVariablesAPI";

import Loader from "components/loader/Loader";
import React, { useCallback, useEffect, useState } from "react";

function PromptVariablesMacrosList(props) {
  const {
    dropdownPosition,
    variablesTableData,
    macroSearch,
    selectedIndex,
    handleMacroSelect,
    setSelectedIndex,
    setVariablesTableData,
    hideDropDown,
  } = props;

  const [isLoading, setIsLoading] = useState(false);

  const getPromptVariables = useCallback(async () => {
    if (macroSearch !== "" || isLoading) return;

    const token = localStorage.getItem("jwtToken");

    try {
      const response = await getPromptVariablesAPI(
        { pageIndex: 0, skip: 50 },
        setIsLoading,
        token
      );

      if (Array.isArray(response.data)) {
        setVariablesTableData(
          Array.isArray(response.data) ? response.data : []
        );
        if (response.length === 0) hideDropDown();
      } else {
        setVariablesTableData([]);
      }
    } catch (error) {
      console.error("Error fetching prompt variables:", error);
    }
  }, [macroSearch, isLoading, setVariablesTableData]);

  const getFilteredVariables = useCallback(async () => {
    if (macroSearch === "") return;

    const token = localStorage.getItem("jwtToken");

    try {
      const response = await getFilterPromptVariablesAPI(
        { searchQuery: macroSearch },
        setIsLoading,
        token
      );

      if (Array.isArray(response.data)) {
        setVariablesTableData(
          Array.isArray(response.data) ? response.data : []
        );
        if (response.length === 0) hideDropDown();
      } else {
        setVariablesTableData([]);
      }
    } catch (error) {
      console.error("Error fetching filtered prompt variables:", error);
    }
  }, [macroSearch, setVariablesTableData]);

  useEffect(() => {
    if (macroSearch === "") {
      getPromptVariables();
    } else {
      getFilteredVariables();
    }
  }, [macroSearch]);

  useEffect(() => {
    const setVH = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    setVH();
    window.addEventListener("resize", setVH);
    return () => window.removeEventListener("resize", setVH);
  }, []);

  const macroDropdownStyles = {
    position: "fixed",
    maxHeight: "calc(var(--vh, 1vh) * 32)",
    overflowY: "auto",
    minWidth: "250px",
    backgroundColor: "white",
    zIndex: 1000,
    WebkitOverflowScrolling: "touch",
    msOverflowStyle: "-ms-autohiding-scrollbar",
    overscrollBehavior: "contain",
    webkitTouchCallout: "none",
    webkitUserSelect: "none",
    webkitTapHighlightColor: "transparent",
  };

  return (
    <div
      className="macro-suggestions absolute rounded-md border border-gray-200 bg-white shadow-lg"
      style={{
        ...macroDropdownStyles,
        top: `${dropdownPosition.top}px`,
        left: `${dropdownPosition.left}px`,
        transform:
          dropdownPosition.position === "above" ? "translateY(-100%)" : "none",
        marginTop: dropdownPosition.position === "below" ? "5px" : "0",
        marginBottom: dropdownPosition.position === "above" ? "5px" : "0",
        boxShadow:
          dropdownPosition.position === "above"
            ? "0 -4px 6px -1px rgba(0, 0, 0, 0.1)"
            : "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
      }}
      onTouchStart={(e) => e.stopPropagation()}
      onTouchMove={(e) => e.stopPropagation()}
    >
      <div className="max-h-full">
        {Array.isArray(variablesTableData) &&
          variablesTableData.map((macro, index) => (
            <div
              key={macro?.id}
              className={`cursor-pointer px-4 py-3 hover:bg-gray-100 active:bg-gray-200 ${
                index === selectedIndex ? "bg-blue-50" : ""
              }`}
              onClick={() => handleMacroSelect(macro)}
              onMouseEnter={() => setSelectedIndex(index)}
              role="option"
              aria-selected={index === selectedIndex}
              tabIndex={0}
            >
              <div className="font-medium">{macro?.name}</div>
              {macro?.value && (
                <div className="text-sm text-gray-500">
                  {macro?.value.length > 50
                    ? `${macro?.value.slice(0, 50)}...`
                    : macro?.value}
                </div>
              )}
            </div>
          ))}

        {isLoading && (
          <div className="flex min-h-[50px] items-center justify-center py-2">
            <Loader />
          </div>
        )}
      </div>
    </div>
  );
}

export default PromptVariablesMacrosList;
